import { Data } from "../types";

import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "name",
        numeric: false,
        disablePadding: true,
        label: "Name",
    },
    {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email",
    },
    {
        id: "maxConcurrentDevices",
        numeric: true,
        disablePadding: true,
        label: "Max Devices",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: true,
        label: "Status",
    },
    {
        id: "startDate",
        numeric: false,
        disablePadding: true,
        label: "Start Date",
    },
    {
        id: "endDate",
        numeric: false,
        disablePadding: true,
        label: "End Date",
    },
    {
        id: "updatedAt",
        numeric: false,
        disablePadding: true,
        label: "Updated At",
    },
];

export default headCells;
